import { gql } from '@apollo/client';

export const GET_FACULTIES = gql`
  query GET_FACULTIES($ids: [ID!], $state: State) {
    faculties(ids: $ids, state: $state) {
      id
      name
      abbreviation
      disabled
      deleted
      controlType
      departments {
        id
        name
        controlType
        abbreviation
        disabled
        deleted
      }
    }
  }
`;

export const ADD_FACULTY = gql`
  mutation ADD_FACULTY($addFacultyInput: AddFacultyInput!) {
    addFaculty(input: $addFacultyInput) {
      id
      name
      abbreviation
      disabled
      deleted
      departments {
        id
        name
        abbreviation
        disabled
        deleted
      }
    }
  }
`;

export const UPDATE_FACULTY = gql`
  mutation UPDATE_FACULTY($updateFacultyInput: UpdateFacultyInput!) {
    updateFaculty(input: $updateFacultyInput) {
      id
      name
      abbreviation
      disabled
      deleted
      departments {
        id
        name
        abbreviation
        disabled
        deleted
      }
    }
  }
`;

export const GET_DEPARTMENTS = gql`
  query GET_DEPARTMENTS($ids: [ID!], $state: State) {
    departments(ids: $ids, state: $state) {
      id
      name
      abbreviation
      controlType
      disabled
      deleted
      faculty {
        id
        name
        abbreviation
        disabled
        deleted
      }
    }
  }
`;

export const ADD_DEPARTMENT = gql`
  mutation ADD_DEPARTMENT($addDepartmentInput: AddDepartmentInput!) {
    addDepartment(input: $addDepartmentInput) {
      id
      name
      abbreviation
      controlType
      disabled
      deleted
    }
  }
`;

export const UPDATE_DEPARTMENT = gql`
  mutation UPDATE_DEPARTMENT($updateDepartmentInput: UpdateDepartmentInput!) {
    updateDepartment(input: $updateDepartmentInput) {
      id
      name
      abbreviation
      controlType
      disabled
      deleted
      faculty {
        id
        name
        abbreviation
      }
    }
  }
`;

export const TOGGLE_DEPARTMENT_DISABLED = gql`
  mutation TOGGLE_DEPARTMENT_DISABLED($id: ID!) {
    toggleDepartmentDisabled(id: $id) {
      id
      name
      abbreviation
      controlType
      disabled
      deleted
      faculty {
        id
        name
        abbreviation
      }
    }
  }
`;

export const DELETE_DEPARTMENT = gql`
  mutation DELETE_DEPARTMENT($id: ID!) {
    deleteDepartment(id: $id) {
      id
      name
      abbreviation
      controlType
      disabled
      deleted
      faculty {
        id
        name
        abbreviation
      }
    }
  }
`;
